import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
import DashboardLayout from "layout/DashboardLayout";
import Error from "layout/Error";
import Error_404 from "pages/Errors/Error_404";
import Error_500 from "pages/Errors/Errors_500";
import Error_401 from "pages/Errors/Error_401";

const WorkSpace = lazy(() => import("pages/WorkSpace"));
const WorkSpaceAdmin = lazy(() => import("pages/WorkSpaceAdmin"));
const Chat = lazy(() => import("pages/Chat"));
const WorkSpaceConfig = lazy(() => import("pages/WorkSpaceConfig"));
const WorkSpaceFormList = lazy(
  () => import("pages/WorkSpaceFormList/WorkSpaceFromList"),
);
const WorkSpaceAccess = lazy(() => import("pages/WorkSpaceAccess"));
const RoleAccess = lazy(() => import("pages/AccessManagement/RoleAccess"));
const User = lazy(() => import("pages/AccessManagement/User"));
const RoleList = lazy(() => import("pages/AccessManagement/Roles"));
const UserManageObject = lazy(() => import("pages/AccessManagement/Objects"));
const Attachment = lazy(
  () => import("pages/WorkSpace/DataTable/component/Attachment"),
);

const WorkspaceAdminAttachment = lazy(
  () => import("pages/WorkSpaceAdmin/DataTable/component/WorkspaceAttachment"),
);
const WorkSpaceForm = lazy(() => import("pages/WorkSpaceForm/WorkSpaceForm"));
const AccessWorkSpace = lazy(
  () =>
    import("pages/WorkSpaceAccess/component/AccessWorkSpace/AccessWorkSpace"),
);
const WorkspaceApiExposure = lazy(
  () => import("pages/WorkSpaceApiExposure/WorkSpaceApiExposure"),
);
const ObjectPage = lazy(
  () => import("pages/AccessManagement/Objects/components/ObjectPage"),
);

const routes = [
  {
    path: "/",
    element: <Navigate to="/chat" />,
  },
  {
    path: "/",
    element: <DashboardLayout />,
    children: [
      {
        path: "workspace",
        element: <WorkSpace />,
      },

      {
        path: "workspaceadmin",
        element: <WorkSpaceAdmin />,
      },

      {
        path: "chat",
        element: <Chat />,
      },
      {
        path: "workspaceconfig",
        element: <WorkSpaceConfig />,
      },
      {
        path: "workspaceaccess",
        element: <WorkSpaceAccess />,
      },
      {
        path: "workspaceaccess_add",
        element: <AccessWorkSpace />,
      },
      {
        path: "workspaceaccess/edit",
        element: <AccessWorkSpace />,
      },
      {
        path: "role_access",
        element: <RoleAccess />,
      },
      {
        path: "user",
        element: <User />,
      },
      {
        path: "roles",
        element: <RoleList />,
      },
      {
        path: "object",
        element: <UserManageObject />,
      },
      {
        path: "workspace/edit",
        element: <Attachment />,
      },
      {
        path: "workspaceAdmin/edit",
        element: <WorkspaceAdminAttachment />,
      },

      {
        path: "workspaceform",
        element: <WorkSpaceFormList />,
      },
      {
        path: "workspaceform/add",
        element: <WorkSpaceForm />,
      },
      {
        path: "workspaceform/edit",
        element: <WorkSpaceForm />,
      },

      {
        path: "workspaceApiExposure",
        element: <WorkspaceApiExposure />,
      },
      {
        path: "object/add",
        element: <ObjectPage />,
      },
      {
        path: "object/edit",
        element: <ObjectPage />,
      },
      {
        path: "errors",
        children: [
          {
            path: "error-404",
            element: <Error_404 />,
          },
          {
            path: "error-500",
            element: <Error_500 />,
          },
          {
            path: "error-401",
            element: <Error_401 />,
          },
        ],
      },

      // Catch-all route for undefined paths (404)
      /*{
        path: "*", // This matches all undefined routes
        element: <Navigate to="/errors/error-404" replace />, // Redirect to the 404 page
      },*/
    ],
  },
  // Separate 404 route if you want direct access to the 404 page
  /*{
    path: "/errors/error-404",
    element: <Error404Page />,
  },*/ // {
  //   path: "/errors",
  //   element: <Error />,  // Error layout
  //   children: [
  //     { path: "error-404", element: <Error_404 /> },  // Error page as a child route
  //     { path: "*", element: <Error_404 /> },  // Wildcard for unmatched routes under /errors
  //   ],
  // },
  {
    path: "*",
    element: <Navigate to="/errors/error-404" replace />,
  },
];

export default routes;
